import { User } from '@/features/users';
import { goCardlessAxiosClient } from '@/lib';
import { AppError, withLogger } from '@/utils';

import { goCardlessAPIUrls } from '../data';

type Params = {
  company_id?: User['company_id'];
};

type Response = {
  status: boolean;
};

type Return = {
  isConnected: boolean;
};

export type CheckStatus = {
  params: Params;
  response: Response;
  return: Return;
};

export const checkGoCardlessStatus = withLogger(
  async (params: Params): Promise<Return> => {
    if (!params.company_id)
      throw new AppError({
        message: 'Invalid company id',
        type: 'invalid-data',
      });

    const url = goCardlessAPIUrls.checkStatus.replace(
      '{COMPANY_ID}',
      params.company_id,
    );
    const response = await goCardlessAxiosClient.get<Response>(url);

    return {
      isConnected: response.data.status,
    };
  },
);
